// ファイルの文字コード　https://dev.classmethod.jp/articles/react-i-tried-sjis-conversion-support-with-csv-output-function-implemented-in-exceljs/

import React, { Component, useState, Fragment } from "react";
import ExcelJS from 'exceljs';
import encoding from "encoding-japanese";
import Cookies from 'js-cookie'

import {addBoardFunction} from './BoardFunction';
import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";

export default class ExcelCsv extends Component{
  state={
    //authObj:{},
    isOpen:false,
    table_data:[[{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]],
    etoile_workbook:''
  }

  componentDidMount () {
    //console.dir(this.props.tonya_id);

		//let staff_token = Cookies.get('_replace_token');
		//let staff_name = Cookies.get('_replace_staff');
		//this.setState({authObj:{"token":staff_token, "name":staff_name}})

  }

    

  
  closeModal = () => {
    this.setState({ isOpen: false });
  }



  render(){

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


    const openModal = async (e) => {
      if(this.props.tonya_name_f!==this.props.data.table_tonya_label){
        console.log('クリック');
        let no_elem = document.querySelectorAll('[data-tonya_id_1="'+this.props.tonya_id+'"]');
        no_elem[0].click();
  
        await sleep(300); //左の問屋番号をクリックしてから Data、ダウンロードボタン押してくれればいいが、いきなり Data ボタンも考えられる、空のレスポンスを返すと混乱の元になるので無理やりクリック操作
        let _button_elem = document.getElementById('excel_download_'+this.props.tonya_id);
        _button_elem.click();
  
        await sleep(300);
        _button_elem.click();
      }
  
      this.setState({ isOpen: true });
  
      const headers = addBoardFunction.getFileHeader(this.props.tonya_id);
      const data = addBoardFunction.getFileData(headers, this.props.tonya_id, this.props.tonya_name_f, this.props.data, '未発注', this.props.data.formData);
  
      let re_array = addBoardFunction.createTableData(Number(this.props.tonya_id), headers, data);
      
      this.setState({table_data:re_array});
      e.preventDefault();
    }


    const handleClickDownload = async (e, format) => {

      //console.dir(e.target);
      //this.props.downloadButton(e.target);//Board.js 使ってないとりあえず
      console.log('CLICK '+String(this.props.tonya_id));
      
      if(this.props.tonya_name_f!==this.props.data.table_tonya_label){
        console.log('クリック');
        let no_elem = document.querySelectorAll('[data-tonya_id_1="'+this.props.tonya_id+'"]');
        no_elem[0].click();

        await sleep(300);
        let _button_elem = document.getElementById('excel_download_'+this.props.tonya_id);
        _button_elem.click();
        
        throw new Error('This script has encountered an error and cannot continue.');
      }

      var dateObject = new Date();
      let today_str ='';
      let today_str_abe ='';
      today_str = (dateObject.getMonth()+1) + '_' + dateObject.getDate() +'_'+dateObject.getHours().toString().padStart(2, '0')+'_'+dateObject.getMinutes().toString().padStart(2, '0') ;
      today_str_abe = dateObject.getFullYear() +'/' + (dateObject.getMonth()+1) + '/' + dateObject.getDate() ;
      
      let f_name = this.props.tonya_name_f+'_'+today_str+'.'+format
      console.log(f_name);


      e.preventDefault();

      let charcode = 'SJIS';

      const headers = addBoardFunction.getFileHeader(this.props.tonya_id);

      let data = [];
      if(this.props.what_type==='researve'){
        data = addBoardFunction.getFileData(headers, this.props.tonya_id, this.props.tonya_name_f, this.props.data, '発注済', this.props.data.formData);  
      }else{
        data = addBoardFunction.getFileData(headers, this.props.tonya_id, this.props.tonya_name_f, this.props.data, '未発注', this.props.data.formData);
      }

      console.dir(data);
      //const headers = [
      //  { header: "管理番号", key: "firstname" },
      //  { header: "JAN", key: "lastname" },
      //  { header: "問屋名", key: "email" }
      //];
      
      //const data = [
      //  { firstname: "1010111", lastname: "29892878262", email: "大島テスト" },
      //  { firstname: "1011111", lastname: "28728627622", email: "大島テスト" },
      //  { firstname: "2292722", lastname: "287262222222", email: "大島テスト" }
      //];

      if(this.props.tonya_id===31){
        f_name = '阿部玩具様発注書.xlsx';
      }

      if(this.props.tonya_id==38 && data.length<=3){
        try{
          if(data[0][0]==='' && data[1][0]==='SCAN' && data[2][0]==='類番(上３桁)'){
            console.log('None Data 3');
            throw new Error('This script has encountered an error and cannot continue.');
          }
        }catch(error){
				}
        if(data.length===0){
          console.log('None Data 0');
          throw new Error('This script has encountered an error and cannot continue.');
        }
      }


      const workbook = new ExcelJS.Workbook();
      let worksheet = '';
      let worksheet_2 = '';
      if(this.props.tonya_id===38){
        //workbook.addWorksheet("注文表");
        //worksheet = workbook.getWorksheet("注文表");
      }else{
        workbook.addWorksheet("sheet1");
        worksheet = workbook.getWorksheet("sheet1");
        worksheet.columns = headers;
        worksheet.addRows(data);
      }



      if(this.props.tonya_id===12 || this.props.tonya_id===13 || this.props.tonya_id===14 || this.props.tonya_id===15){
        worksheet.duplicateRow(1, 1, true);
        const newRow = worksheet.getRow(1);
        newRow.values = ['title', '', '', '', ''];
      }else if(this.props.tonya_id===31){
        worksheet.duplicateRow(1, 1, true);
        worksheet.duplicateRow(1, 1, true);
        worksheet.duplicateRow(1, 1, true);
        let newRow_1 = worksheet.getRow(1);
        let newRow_2 = worksheet.getRow(2);
        let newRow_3 = worksheet.getRow(3);
        newRow_1.values = ['', '阿部玩具様発注書', '', '', '', '', today_str_abe];
        newRow_2.values = ['', '', '', '', '', '', ''];
        newRow_3.values = ['', '', '', '', '', '', ''];

        let howmany_order = data.length;

        let newRow_4 = worksheet.addRow(4+howmany_order);
        newRow_4.values = ['', '', '', '', '', '', ''];
        let newRow_5 = worksheet.addRow(5+howmany_order);
        newRow_5.values = ['', '送り先名：株式会社リミックス 　ポッチ', '', '', '', '', ''];
        let newRow_6 = worksheet.addRow(6+howmany_order);
        newRow_6.values = ['', '郵便番号：〒452-0034', '', '', '', '', ''];
        let newRow_7 = worksheet.addRow(7+howmany_order);
        newRow_7.values = ['', '住所　　：愛知県 清須市西枇杷島町日之出1-2', '', '', '', '', ''];
        let newRow_8 = worksheet.addRow(8+howmany_order);
        newRow_8.values = ['', '電話番号：070-8332-6359', '', '', '', '', ''];
        let newRow_9 = worksheet.addRow(9+howmany_order);
        newRow_9.values = ['', '', '', '', '', '株式会社リミックス', ''];
        let newRow_10 = worksheet.addRow(10+howmany_order);
        newRow_10.values = ['', '', '', '', '', '発注担当：'+this.props.data.auth_obj.name, ''];

        worksheet.columns.forEach((column, index) => {
          if(index===0){
            column.width = 10;
          }else if(index===1){
            column.width = 35;
          }else if(index===2){
            column.width = 50;
          }else if(index===3){
            column.width = 15;
          }else if(index===4){
            column.width = 15;
          }else if(index===5){
            column.width = 15;
          }else if(index===6){
            column.width = 15;
          }
        })

        let col_array = ['B', 'C', 'D', 'E', 'F', 'G'];
        for (let i = 0; i < col_array.length; i++) {
          let start = 4;
          let end = start+howmany_order+1;
          while(start<end){
            let cell = col_array[i]+String(start);
            let range = worksheet.getCell(cell);
            range.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
            start++;
          }
        }


        const range = worksheet.getCell('B4');
        range.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

      }else if(this.props.tonya_id===38){
        workbook.addWorksheet("例");
        worksheet = workbook.getWorksheet("例");
        let dammy_data = addBoardFunction.getDammyData();
        worksheet.addRows(dammy_data);
        worksheet = addBoardFunction.addFomula('dammy', worksheet, 37);
        console.log('ok worksheet_1');

        workbook.addWorksheet("注文表");
        worksheet_2 = workbook.getWorksheet("注文表");
        data = addBoardFunction.addEtoileHeader(data);
        worksheet_2.addRows(data);
        worksheet_2 = addBoardFunction.addFomula('real', worksheet_2, data.length);
        console.log('ok worksheet_2');
      }

    

      const uint8Array =
      format === "xlsx"
        ? await workbook.xlsx.writeBuffer()
        : charcode === "UTF8"
        ? await workbook.csv.writeBuffer()
        : new Uint8Array(
            encoding.convert(await workbook.csv.writeBuffer(), {
              from: "UTF8",
              to: "SJIS"
            })
          );
      const blob = new Blob([uint8Array], {
        type: "application/octet-binary"
      });
      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = f_name;
      a.click();
      a.remove();
  

      //
      addBoardFunction.createBackUp(this.props.data.auth_obj, headers, data, f_name, this.props.tonya_id);

      e.preventDefault();
    }



    var copy_table_data = async (e) => {
      let tr_elems = document.getElementsByClassName('copy_data_table')[0].childNodes[0].childNodes[1].childNodes;
      console.dir(tr_elems);



    }

    let button_class_name = '';
    if(this.state.isOpen){
      button_class_name = 'btn btn-sm btn-secondary  a-small';
    }else{
      button_class_name = 'btn btn-sm btn-outline-secondary  a-small';
    }

    let isit_data = false;
    if(this.props.tonya_name_f==='マルク.xlsx' || this.props.tonya_name_f==='三共在庫.csv' || this.props.tonya_name_f==='アサヒサイクル.xlsx' || this.props.tonya_name_f==='アサヒシューズ.xlsx' || this.props.tonya_name_f==='ナビリオン当日.xlsx' || this.props.tonya_name_f==='ナビリオン.xlsx' || this.props.tonya_name_f==='ナビリオン愛知以外（当日）.xlsx' || this.props.tonya_name_f==='ナビリオン愛知以外.xlsx' || this.props.tonya_name_f.indexOf('単品特価') !== -1){
      isit_data = true;
    }
    

    return (
      <div className={this.props.style_class}>
        {isit_data===false ? 
          <>
            <button onClick={event=>handleClickDownload(event, this.props.format)} className={button_class_name} id={'excel_download_'+String(this.props.tonya_id)}>{this.props.format}</button>
          </> : 
          <>
            {this.state.isOpen ? <button onClick={this.closeModal} className={button_class_name}>閉じる</button> : <button onClick={event=>openModal(event)} className={button_class_name}  id={'excel_download_'+String(this.props.tonya_id)}>Data</button>}
          
            {this.state.isOpen ? <>
              <div className="maruku-hattyuu-table-style">
                {/* 単品特価まとめて処理する場合
                {
                  this.props.tonya_name_f.indexOf('単品特価') !== -1 ? 
                    <>
                      {this.state.table_data.map((row, index)=>{
                        <p>{row}</p>
                      })}

                    </> 
                    : 
                    <>
                      <Spreadsheet 
                        data={this.state.table_data} 
                        className="copy_data_table"
                      />  
                    </>
                }
                */}
        
                <>
                  <Spreadsheet 
                    data={this.state.table_data} 
                    className="copy_data_table"
                  />  
                </>

                {/* <button className="btn btn-sm btn-primary  a-small maruku_copy_button" onClick={(e)=>{copy_table_data(e)}} >コピーする</button> */}
              </div>

            </> : <></>}  
          </>
        }


      </div>


    )

  }

}